import React, { useEffect, useState } from 'react'
import { Backdrop } from 'src/global'
import {
  Modal,
  Header,
  CloseButtonWrapper,
  ModalContent,
  ModalFooter,
  FieldWrapper,
  CloseButtonLineOne,
  CloseButtonLineTwo,
} from '../../../HomeScreen/ProductModal/styles'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import Button from 'src/global/Button'
import { User, UserPatchType, getDaysLeft } from '@meniudigital/shared'
import useForm from 'src/helpers/useForm'
import { useDispatch } from 'react-redux'
import { patchUser } from 'src/state/users'
import moment from 'moment'

export default function UserModal() {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [initialEmail, setInitialEmail] = useState<string>('')
  const { formValues, register, setValue } = useForm()
  const dispatch = useDispatch()

  useEffect(() => {
    window.openUserEditModal = open
  }, [])

  const open = (user: User) => {
    setIsOpen(true)
    setInitialEmail(user.email || '')
    ;['name', 'city', 'id', 'email'].forEach(key => setValue(key, (user as any)[key]))
    setValue('coordsString', [user.coords?.latitude, user.coords?.longitude].filter(Boolean).join(','))

    // Calculate days left from subscriptionExpiresAt
    const daysLeft = user.subscriptionExpiresAt ? getDaysLeft(user.subscriptionExpiresAt) : ''
    setValue('daysLeft', daysLeft.toString())
  }

  const save = async () => {
    if (!isUserValid()) {
      return
    }

    let coords = undefined

    const coordsString = formValues['coordsString']?.value
    if (coordsString?.length) {
      const [latitudeString = '', longitudeString = ''] = coordsString.split(',')

      const latitude = +latitudeString.trim()
      const longitude = +longitudeString.trim()

      if (!latitude || !longitude) {
        return window.showModal({
          title: `Coordonate invalide`,
          text: `Coordonatele introduse nu sunt valide. Verifică că formatul coordonatelor e corect (latitudine,longitudine) și încearcă din nou.`,
          confirmButtonText: 'Ok',
          isConfirm: true,
        })
      } else {
        coords = {
          latitude,
          longitude,
        }
      }
    }

    // Calculate subscriptionExpiresAt from daysLeft
    let subscriptionExpiresAt = undefined
    const daysLeftValue = formValues['daysLeft']?.value
    if (daysLeftValue !== '' && daysLeftValue !== undefined) {
      const daysLeft = parseInt(daysLeftValue, 10)
      if (!isNaN(daysLeft)) {
        subscriptionExpiresAt = moment().add(daysLeft, 'days').endOf('day').toDate()
      }
    }

    const name = (formValues['name'].value || '').trim()
    const email = (formValues['email'].value || '').trim()

    if (email !== initialEmail) {
      await window.showConfirm({
        title: 'Confirmă schimbarea emailului',
        text: `Pentru ${name}, noua adresă de email va fi ${email}. Clientul se va loga cu noua adresă.`,
        isConfirm: true,
        confirmButtonText: 'Da, schimbă',
        cancelButtonText: 'Anulează',
      })
    }

    // @ts-ignore
    await dispatch(
      patchUser({
        type: UserPatchType.FromAdminInterface,
        data: {
          name,
          city: (formValues['city'].value || '').trim(),
          coords,
          subscriptionExpiresAt,
          email,
        },
        userId: formValues['id'].value,
      }),
    )

    window.location.reload()

    close()
  }

  const isUserValid = () => {
    if (!formValues['name']?.value.length || !formValues['city']?.value.length) {
      return false
    }

    if (!/^\S+@\S+\.\S+$/.test(formValues['email']?.value || '')) {
      return false
    }

    return true
  }

  const close = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Backdrop onClick={close} className={isOpen ? 'open' : 'closed'} />
      <input type="hidden" {...register('id')} />
      <Modal style={{ width: '400px' }} className={isOpen ? 'open' : 'closed'}>
        <Header>
          Modifică date client
          <CloseButtonWrapper onClick={close} title="Închide">
            <CloseButtonLineOne />
            <CloseButtonLineTwo />
          </CloseButtonWrapper>
        </Header>
        <ModalContent>
          <FieldWrapper>
            <label>Numele restaurantului / localului</label>
            <input placeholder="Numele restaurantului!!" maxLength={200} {...register('name')} />
          </FieldWrapper>
          <FieldWrapper>
            <label>Email (adresa de logare)</label>
            <input type="email" placeholder="email@exemplu.ro" maxLength={200} {...register('email')} />
          </FieldWrapper>
          <FieldWrapper>
            <label>Localitate, județ</label>
            <input placeholder="Oraș, jud. Județ" maxLength={200} {...register('city')} />
          </FieldWrapper>
          <FieldWrapper>
            <label>Coordonate</label>
            <input
              placeholder="latitudine,longitudine"
              style={{ paddingRight: 0 }}
              maxLength={200}
              {...register('coordsString')}
            />
          </FieldWrapper>
          <FieldWrapper>
            <label>Zile rămase din abonament</label>
            <input type="number" placeholder="e.g. 30, 180, 365" {...register('daysLeft')} />
          </FieldWrapper>
        </ModalContent>
        <ModalFooter>
          <Button variant="as-text" onClick={close} text="Închide" />
          <Button onClick={save} text="Salvează" disabled={!isUserValid()} icon={faCheck} />
        </ModalFooter>
      </Modal>
    </>
  )
}
